export const SERVER_EMAIL_ERROR = 'Invalid E-mail'
